import { authFetch } from "../utils/authFetch";
import { baseUrl } from "../utils/requestUrl";

export const getUsersByOrg = async (pageNumber = 1, pageSize = 10) => {
  const organizationId = JSON.parse(localStorage.getItem('user')).organizations?.find((org)=>org.active === true)?.id;
  try {
    const response = await authFetch(`${baseUrl}/organization/${organizationId}/users?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    return response.json();
  } catch (error) {
    
    throw error;
  }
};

export const createUser = async (userData) => {
  try {
    const response = await authFetch(`${baseUrl}/user/register`, {
      method: 'POST',
      body: JSON.stringify(userData),
    });
    return response.json();
  } catch (error) {
    throw error;
  }
};

export const searchCareProviders = async (name = "") => {
  const user = JSON.parse(localStorage.getItem("user"));
  const organizationId = user?.organizations?.find((org)=>org.active === true)?.id;
  try {
    const response = await authFetch(`${baseUrl}/careProviders/byOrganization/${organizationId}?name=${name}`);
    return response.json();
  } catch (error) {
    throw error;
  }
};

// Step 1 of the two-step registration (docs/two-step-registration.md §1): create
// or look up the person. A 404 here is NOT a failure — it means the email is
// already registered and the body still carries that user, so the caller can
// take the id straight into step 2.
export const registerBasicInfo = async (basicInfo) => {
  const response = await authFetch(`${baseUrl}/user/register/basic-info`, {
    method: 'POST',
    body: JSON.stringify(basicInfo),
  });
  const body = await response.json();

  if (response.ok || (response.status === 404 && body?.data)) {
    return { user: body?.data, alreadyExists: response.status === 404 };
  }
  throw new Error(body?.message || "Couldn't save the user's details.");
};

// Step 2 (docs/two-step-registration.md §2): link the user to a clinical
// location, assign the role(s)/position and send the welcome email. Every
// completed call sends another email, so only call it once per user.
export const registerLocation = async (locationData) => {
  const response = await authFetch(`${baseUrl}/user/register/location`, {
    method: 'POST',
    body: JSON.stringify(locationData),
  });
  const body = await response.json();

  if (!response.ok) {
    throw new Error(body?.message || "Couldn't assign the location and role.");
  }
  return body;
};
